import { Box, Button, Circle, IconButton, Image, Menu, MenuButton, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setEdit } from "../../redux/actions/actions";
import { ReactComponent as ContextMenuIcon } from '../../svg/ContextMenu.svg'


export default function MobileQuizzesCard({ name, dates, participants, questions, id, removeQuiz }) {
    const [extraParticipantsCount, setExtraParticipantsCount] = useState(0)
    const [visibleParticipants, setVisibleParticipants] = useState([])
    const dispatch = useDispatch()
    const history = useHistory()


    const setVisibleEmployees = () => {
        setVisibleParticipants(employeesToDisplay(participants))
    }

    useEffect(() => {
        setVisibleEmployees()
        // eslint-disable-next-line
    }, [])

    const employeesToDisplay = (employees) => {
        if (employees.length > 6) {
            setExtraParticipantsCount(participants.length - 5)
            return employees.slice(0, 6)
        }
        else {
            return employees
        }
    }

    const editHandler = () => {
        localStorage.removeItem('questions')
        localStorage.removeItem('quizId')
        dispatch(setEdit(id))
        history.push('/add-quizzes')
    }

    const manageQuestionsHandler = () => {
        localStorage.removeItem('questions')
        localStorage.removeItem('quizId')
        dispatch(setEdit(id))
        history.push({
            pathname: '/add-quizzes',
            state: { nextClicked: true }
        })
    }

    return (
        <Box
            d='flex'
            width='100%'
            bg='white'
            borderRadius='2xl'
            my='1rem'
            justifyContent='center'
            alignItems='flex-start'
            flexDirection='column'
            _hover={{ boxShadow: 'xl' }}
            px={['1rem', '1rem', '2rem']}
            pt={['1.5rem', '1.5rem', '2rem']}
        >
            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='flex-start'
                width='100%'
                mb='1rem'
            >
                <Box
                    d='flex'
                    flexDir='column'
                    alignItems='flex-start'
                    justifyContent='center'
                >
                    <Text
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize='15px'
                        color='#798599'
                    >
                        Quiz
                    </Text>

                    <Text
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize='18px'
                        color='#333333'
                    >
                        {name}
                    </Text>
                    {
                        dates &&
                        <Text
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            fontWeight='400'
                            fontSize='18px'
                            color='#00000080'
                        >
                            {dates}
                        </Text>
                    }
                </Box>

                <Menu>
                    <MenuButton
                        as={IconButton}
                        // mr='1rem'
                        border='2px solid rgba(0, 0, 0, 0.1)'
                        icon={<ContextMenuIcon />}
                        bg='white'
                        _hover={{ bg: "#f8f8f8" }}
                        _active={{ bg: "#f8f8f8" }}
                        size={['xs', 'sm', 'sm', 'lg']}
                        px='2'
                        py='1'
                    />
                    <MenuList style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize='15px' color='#00000099' minW='0' w='150px' position='relative' zIndex='10' >
                        <MenuItem onClick={editHandler}>Edit</MenuItem>
                        <MenuItem onClick={() => removeQuiz(id)}>Delete</MenuItem>
                    </MenuList>
                </Menu>
            </Box>
            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='flex-start'
                width='100%'
            >
                <Box
                    d='flex'
                    flexDir='column'
                    alignItems='flex-start'
                    justifyContent='center'
                    width={['60%', '60%', '50%']}
                >
                    <Text
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize={['12px', '14px', '15px']}
                        color='#798599'
                        mb='1rem'
                    >
                        Participants
                    </Text>
                    <Box
                        d='flex'
                        position='relative'
                        height='100px'
                        width='100%'
                    >
                        {
                            visibleParticipants.map((employee, idx) => <Image
                                key={idx}
                                src={employee}
                                width='60px'
                                height='60px'
                                position='absolute'
                                zIndex={idx + 1}
                                left={idx === 0 ? '0' : `${idx * 12.5}%`}
                                borderRadius='50%'
                            />
                            )
                        }
                        {
                            extraParticipantsCount > 0 &&

                            <Circle
                                bg='#00000080'
                                size='60px'
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontWeight='700'
                                fontSize='20px'
                                color='white'
                                position='absolute'
                                zIndex='7'
                                left={`${(visibleParticipants.length - 1) * 12.5}%`}
                            >
                                {extraParticipantsCount}+
                            </Circle>
                            // </Box>
                        }
                    </Box>

                </Box>
                <Box
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='flex-end'
                    width={['40%', '40%', '50%']}
                    flexDirection='column'
                    height='100px'
                >
                    <Text
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize={['12px', '14px', '15px']}
                        color='#798599'
                        mb='1rem'

                    >
                        Questions
                    </Text>

                    <Circle bg='#F56A79' size='40px' border='1px solid white' color='white' style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize='15px'>
                        {questions}
                    </Circle>
                </Box>
            </Box>

            <Box
                d='flex'
                justifyContent='flex-end'
                alignItems='center'
                width='100%'
                mb='1rem'
            >
                <Button
                    bgColor='#F56A79'
                    color='white'
                    variant='outline'
                    p='0.75rem'
                    size={['sm', 'sm', 'md']}
                    fontWeight='700'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    borderRadius='lg'
                    fontSize={['11px', '13px', '15px']}
                    _hover={{ bg: "#dc5f6b" }}
                    onClick={manageQuestionsHandler}
                >
                    Manage Questions
                </Button>

            </Box>
        </Box>
    )
}